/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { inventoryDestroy } from '../../axios/inventoryDestroy'
import type {
	InventoryDestroyError,
	InventoryDestroyPathParams,
	InventoryDestroyResponse,
} from '../../types/InventoryDestroy'

export const inventoryDestroyMutationKey = () => [{ url: '/:organisation/inventory/:item' }] as const

export type InventoryDestroyMutationKey = ReturnType<typeof inventoryDestroyMutationKey>

export type InventoryDestroyVariables = {
	organisation: InventoryDestroyPathParams['organisation']
	item: InventoryDestroyPathParams['item']
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::destroy */
export function useInventoryDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		InventoryDestroyResponse,
		AxiosError<InventoryDestroyError>,
		InventoryDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: inventoryDestroyMutationKey(),
		mutationFn: ({ organisation, item }: InventoryDestroyVariables) =>
			inventoryDestroy(organisation, item, config).then(res => res.data),
		...options,
	})
}
